import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocGlobalAlertListRedirectRoute: InvariantJiraRoute = {
	name: 'eoc-global-alerts-redirect',
	path: '/jira/ops',
	exact: true,
};
